export enum CheckoutServiceEvent {
	INITIALIZED,
	CONFIG_LOADED,
	SUBMIT_PAYMENT,
	PAYMENT_SUBMISSION_SUCCESSFUL,
	PAYMENT_SUBMISSION_ERROR
}
